/*
 * @Author: chenchaoqiang@leedarson.com
 * @Date: 2021-11-15 11:31:49
 * Copyright 2021 Leedarson, All Rights Reserved.
 */

class NativePayment {
  constructor({ native }) {
    this.native = native;
  }

  createApplePay(vs) {
    return this.native.send({
      key: 'IAP.payment',
      ...vs,
    });
  }
}

export default NativePayment;
